import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import {
  selectDataToExecuteInventory, selectDataPosition, selectIsThirdCount, selectNeedGetPosition,
} from '../../InventorySelector'
import { actions } from '../../InventoryState'

export default ({
  open, setOpen, setHasPosition, inventoryToExecute, setClickStartPosition,
}) => {
  const dispatch = useDispatch()
  const position = useSelector(selectDataPosition)
  const { badge, floor, addressesTypes } = useSelector(selectDataToExecuteInventory)
  const isThirdCount = useSelector(selectIsThirdCount)
  const needGetPositions = useSelector(selectNeedGetPosition)

  useEffect(() => {
    if (needGetPositions === true) {
      dispatch(actions.getPosition({
        badge,
        floor,
        addressesTypes,
        id: inventoryToExecute.id,
        isThirdCount,
        afterFinishPosition: true,
      }))
      setClickStartPosition(false)
      dispatch(actions.setNeedGetPosition(false))
    }
  }, [needGetPositions, dispatch, badge, floor, addressesTypes, inventoryToExecute, isThirdCount, setClickStartPosition])

  const onConfirmModal = () => {
    dispatch(actions.finishPosition({
      idPosition: position.idPosition,
      badge,
    }))
    setHasPosition(false)
    setOpen(false)
  }

  return (
    <ConfirmOrRejectModal
      show={open}
      title='Finalizar Posição'
      description='Você tem certeza que deseja finalizar a posição?'
      onConfirm={() => onConfirmModal()}
      onReject={() => setOpen(false)}
      onClose={() => setOpen(false)}
    />
  )
}
